import { useCallback, useMemo } from 'react';
import { cn } from '@divlab/divanui';
import { IconChevronRight } from '@divlab/divanui/icons';

import useMedias from '@Hooks/useMedias';
import useNavigation from '@Navigation/useNavigation';
import Timer from '../Timer';
import styles from './InfoStripe.module.css';

import type { FC, HTMLAttributes, MouseEvent } from 'react';
import type { InfoStripeData } from '@Types/Base';

export interface InfoStripeProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  infoStripe: InfoStripeData;
}

const INFOSTRIPE_MAX_LENGTH_MOBILE = 72;
const INFOSTRIPE_MAX_LENGTH_MOBILE_M = 84;

const InfoStripe: FC<InfoStripeProps> = (props) => {
  const { className, infoStripe, ...restProps } = props;
  const { isMobile, isMobileM } = useMedias();
  const navigation = useNavigation();

  const text = useMemo(() => {
    const t = infoStripe.mobileText || infoStripe.text;
    const maxLengthConst = isMobile ? INFOSTRIPE_MAX_LENGTH_MOBILE : INFOSTRIPE_MAX_LENGTH_MOBILE_M;
    const maxLength = infoStripe.timer?.title
      ? maxLengthConst - infoStripe.timer.title.length
      : maxLengthConst;

    if (isMobileM) return t.length > maxLength ? `${t.substring(0, maxLength)}...` : t;

    return infoStripe.text;
  }, [infoStripe.mobileText, infoStripe.text, infoStripe.timer?.title, isMobile, isMobileM]);

  const handleClickTopline = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();

      switch (infoStripe.view) {
        case 'external':
          if (!infoStripe.link) return;

          window.open(infoStripe.link, '_blank');
          break;

        default:
          if (!infoStripe.link) return;

          navigation.openPage({ url: infoStripe.link });
          break;
      }
    },
    [infoStripe.link, infoStripe.view, navigation],
  );

  return (
    <div {...restProps} className={cn(styles.wrapper, className)} onClick={handleClickTopline}>
      <div className={styles.wrapperText}>
        {text && (
          <span
            className={cn(styles.textOffset, styles.textStyle)}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: text }}
          />
        )}
        {infoStripe.link && !infoStripe.timer && (
          <>
            {' '}
            <span className={styles.wrapperArrow}>
              <IconChevronRight className={styles.rArrow} />
            </span>
          </>
        )}
      </div>
      {infoStripe.timer && (
        <div className={styles.timerWrapper}>
          <div className={cn(styles.timerText)}>{`${infoStripe.timer?.title}`}</div>
          {` `}
          <Timer className={styles.textStyle} timer={infoStripe.timer} />{' '}
          {infoStripe.link && (
            <span className={styles.wrapperArrow}>
              <IconChevronRight className={styles.rArrow} />
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default InfoStripe;
